import {
  userProfileLoadBegin,
  userProfileLoadSuccess,
  userProfileLoadFailed,
  userProfileUpdateFailed,
  userProfileUpdateSuccess,
} from "../actions/userProfileActions";

import { LOAD_DEPENDANT_FIELDS_SUCCESS } from "../actions/dependantActions";

const initialState = {
  user: {},
  fetching: false,
  fetched: false,
  error: null,
  isCreationAllowed: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case userProfileLoadBegin:
      return { ...state, fetching: true };

    case userProfileLoadFailed:
      return { ...state, fetching: false, error: action.payload };

    case userProfileLoadSuccess: {
      const user = action.payload;
      const { employee: { data }, dependantListDTO } = user;
      const dependants = (dependantListDTO
        ? dependantListDTO.dependants
        : []).map(dependant => ({
        ...dependant,
        data: dependant.data.reduce(
          (obj, item) => ({ ...obj, [item.id]: item.value }),
          {}
        ),
      }));

      return {
        ...state,
        fetching: false,
        fetched: true,
        user: {
          ...user,
          employee: {
            ...user.employee,
            data: data.reduce(
              (obj, item) => ({ ...obj, [item.id]: item.value }),
              {}
            ),
          },
          dependantListDTO: {
            ...dependantListDTO,
            dependants,
          },
        },
      };
    }

    case userProfileUpdateSuccess: {
      const data = action.payload.Data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        user: {
          ...state.user,
          employee: {
            ...state.user.employee,
            data: data.reduce(
              (obj, item) => ({ ...obj, [item.id]: item.value }),
              {}
            ),
          },
        },
      };
    }

    case userProfileUpdateFailed: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: action.payload,
      };
    }

    case LOAD_DEPENDANT_FIELDS_SUCCESS: {
      return { ...state, isCreationAllowed: action.payload.isCreationAllowed };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/userProfileReducer.jsx